/**
 * Cart
 **/
app.add({

    init: function(app){
        app.cart = this;
    },

    onLoad: function(){
        $('.form--cart select[name="country"], .form--cart select.item-quantity').each(function(){
            this.addEventListener('change', app.cart);
            app.cart.handleEvent({target: this});
        });
        app.notify('cartLoad');
    },

    items: {},
    total: 0,
    shipping: 0,

    handleEvent: function(e){
        if (/item-quantity/.test(e.target.className)) {
            this.setProduct(e.target);
        } else {
            this.setShipping(e.target.value);
        }
        this.updateTotal();
    },

    count: function(){
        var l = 0;
        for (var i in this.items){
            l += this.items[i].qty;
        }
        return l;
    },

    setProduct: function(product){
        this.items[product.getAttribute('data-product-id')] = {
            qty: parseInt(product.value),
            price: parseFloat(product.getAttribute('data-product-price')),
        };
    },

    updateTotal: function(){
        var total = 0,
            firstCounted = false,
            moreThanOneItems = this.count() > 1;

        for (var id in this.items){
            var line_total = 0;
            var item = this.items[id];
            var price = item.price;
            for (var i = 0; i < item.qty; i++) {
                var itemPrice = price;
                if (moreThanOneItems) {
                    if (!firstCounted) {
                        firstCounted = true;
                    }
                    else {
                        itemPrice = price - 10;
                    }
                }
                line_total += itemPrice;
            }
            total += line_total;
            $('.form--cart .item-total-id-'+id).text('$'+line_total.toFixed(2));
        }

        total += this.shipping;
        this.total = total;

        $('.form--cart .cart .total').text('$'+total.toFixed(2));
    },

    setShipping: function(country){
        if (country) {
            var free_destinations = fallacy_data.free_destinations || [];
            var shipping_is_free = $.inArray(country, free_destinations) !== -1;
            this.shipping = parseFloat(shipping_is_free ? 0 : (fallacy_data.shipping_price || 19));
        } else {
            this.shipping = 0;
        }
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/cart.js